import { useState, useEffect } from "react";
import api from "@/lib/api";
import { useShop } from "@/contexts/ShopContext";
import { toast } from "sonner";

export default function Settings() {
  const { currentShop, reloadShops } = useShop();
  const [workingHours, setWorkingHours] = useState("");
  const [contact, setContact] = useState("");
  const [acceptOnline, setAcceptOnline] = useState(true);
  const [confirmText, setConfirmText] = useState("");

  useEffect(() => {
    if (currentShop) {
      setWorkingHours(currentShop.working_hours || "");
      setContact(currentShop.contact_number || "");
      setAcceptOnline(currentShop.accept_online_orders);
    }
  }, [currentShop]);

  const save = async () => {
    await api.patch(`/shops/${currentShop.id}`, { working_hours: workingHours, contact_number: contact, accept_online_orders: acceptOnline });
    toast.success("Settings saved");
    reloadShops();
  };

  const clearHistory = async () => {
    await api.post(`/shops/${currentShop.id}/clear-history`);
    toast.success("Order history cleared");
    setConfirmText("");
  };

  if (!currentShop) return null;

  return (
    <section className="view" data-testid="settings-page">
      <div className="page-head">
        <div>
          <div className="eyebrow">Quiet controls</div>
          <h1>Settings</h1>
          <p>Shop settings visible to staff on this station.</p>
        </div>
      </div>
      <div className="card">
        <div className="section-head"><div><h2>Shop settings</h2></div></div>
        <div className="field" style={{ padding: "16px 20px 0" }}><label className="field-label">Working hours</label><input className="input" style={{ width: "100%" }} value={workingHours} onChange={(e) => setWorkingHours(e.target.value)} data-testid="settings-hours-input" /></div>
        <div className="field" style={{ padding: "12px 20px 0" }}><label className="field-label">Contact number</label><input className="input" style={{ width: "100%" }} value={contact} onChange={(e) => setContact(e.target.value)} data-testid="settings-contact-input" /></div>
        <div className="setting-row">
          <div><strong>Accept online orders</strong><small>Let customers place orders while the shop is open.</small></div>
          <button className={`toggle ${acceptOnline ? "on" : ""}`} onClick={() => setAcceptOnline((v) => !v)} data-testid="accept-online-toggle"><i /></button>
        </div>
        <div style={{ padding: "0 20px 20px" }}><button className="btn btn-primary" onClick={save} data-testid="save-settings-btn">✓ Save settings</button></div>
      </div>
      <div className="card" style={{ marginTop: 20, borderColor: "var(--red)" }}>
        <div className="section-head"><div><h2 style={{ color: "var(--red)" }}>Danger zone</h2></div></div>
        <div style={{ padding: "16px 20px" }}>
          <p style={{ fontSize: 12, margin: "0 0 10px" }}>Deletes every order for this shop and resets the daily order number to 0. Menu items and staff accounts are not affected. This can't be undone.</p>
          <label className="field-label">Type CONFIRM to proceed</label>
          <input className="input" value={confirmText} onChange={(e) => setConfirmText(e.target.value)} placeholder="CONFIRM" style={{ width: 220, margin: "8px 0 12px" }} data-testid="confirm-clear-input" />
          <br />
          <button className="btn btn-danger" disabled={confirmText !== "CONFIRM"} onClick={clearHistory} data-testid="clear-history-btn">Clear order history</button>
        </div>
      </div>
    </section>
  );
}
